/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   FilterMoodal selectors
 */

import type { State } from '@zcode/state-type'
import { compose } from 'redux'

const selectRoot = (state: State) => state.filters
export const selectFilterModal = compose((state) => state.filterModal, selectRoot)

export const selectFilterModalType = compose((state) => state?.filterModalType, selectFilterModal)

export const selectIsFilterModalOpen = compose(
  (state) => state?.isFilterModalOpen,
  selectFilterModal
)

export const selectIsShortTermCalendarPickerOpen = compose(
  (state) => state?.isShortTermCalendarPickerOpen,
  selectFilterModal
)
